import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {TokenService} from '../services/token.service';
import {Observable} from 'rxjs';

@Injectable()
export class LoggedOutGuard {
  constructor(
    private authService: TokenService,
    private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    // if (this.authService.isAuthenticated()) {
    //   this.router.navigate([
    //     '/',
    //     'home'
    //   ]);
    //   return false;
    // }

    return true;
  }
}
